<template>

  <div class="nav-title">
  
    <a
      v-for="title, i in titles"
      class="nav-title__item"
      @click="goToItem(i)"
    >{{ title.textContent }}</a>
  
  </div>

</template>

<script>
  import $ from 'jquery';
  import Utils from '@/mixins/Utils';

  export default {
    name: 'TheNavTitles',

    mixins: [
      Utils,
    ],

    data() {
      return {
        titles: [],
      };
    },

    watch: {
      isMobile(bool) {
        if (bool) {
          this.destroy();
        } else {
          this.init();
        }
      },
    },

    mounted() {
      if (!this.isMobile) {
        this.init();
      }
    },

    beforeDestroy() {
      this.destroy();
    },

    methods: {
      init() {
        this.update();

        window.addEventListener('scroll', this.update);
      },

      destroy() {
        window.removeEventListener('scroll', this.update);

        this.titles.forEach((item) => {
          item.classList.remove('title_hide');
        });

        this.titles.length = 0;
      },

      update() {
        const titles = document.querySelectorAll('.title_h2');
        const targetPosition = document
          .querySelector('.nav-title')
          .getBoundingClientRect();

        titles.forEach((item, index) => {
          const position = item.getBoundingClientRect();

          if (position.bottom <= targetPosition.bottom + 40) {
            const index = this.titles.indexOf(item);

            if (index === -1) {
              this.titles.push(item);
              item.classList.add('title_hide');
            }
          } else {
            const index = this.titles.indexOf(item);

            if (index !== -1) {
              this.titles.splice(index, 1);
              item.classList.remove('title_hide');
            }
          }
        });
      },

      goToItem(item) {
          const el = $('.layout_default-page').eq(item);
          const top = el.offset().top - 300;
          $('html, body').animate({scrollTop: top});
      },
    },
  };
</script>


// WEBPACK FOOTER //
// src/components/TheNavTitles.vue